import { httpPost, httpPatchMerge, httpDelete } from './http'
import type { TEntityId } from '~/types/models'
import type { IOpportunityMSTeamMember } from '~/types/opportunity/models'

const apiEntityPath = '/api/opportunitymsteammembers'

export async function createOpportunityMSTeamMember(
  entity: IOpportunityMSTeamMember
) {
  const callingMn = createOpportunityMSTeamMember.name
  const apiPath = apiEntityPath
  return httpPost<IOpportunityMSTeamMember>({
    callingMn,
    apiPath,
    entity,
  })
}

export async function updateOpportunityMSTeamMember(
  entityData: Partial<IOpportunityMSTeamMember>,
  id: TEntityId
) {
  const callingMn = updateOpportunityMSTeamMember.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialOpportunityMSTeamMember = Partial<IOpportunityMSTeamMember>
  return httpPatchMerge<TPartialOpportunityMSTeamMember>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteOpportunityMSTeamMember(
  entityData: IOpportunityMSTeamMember
) {
  const callingMn = deleteOpportunityMSTeamMember.name
  const apiPath = apiEntityPath
  return httpDelete<IOpportunityMSTeamMember>({
    callingMn,
    apiPath,
    entityData,
  })
}
